export default "__VITE_ASSET__uzZb$dmW__"